import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export const MusicToggle = () => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const start = () => {
      if (audioRef.current && localStorage.getItem("ip_muted") !== "1") {
        audioRef.current.volume = 0.22;
        audioRef.current
          .play()
          .then(() => setPlaying(true))
          .catch(() => {});
      }
      window.removeEventListener("pointerdown", start);
    };
    window.addEventListener("pointerdown", start);
    return () => window.removeEventListener("pointerdown", start);
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      localStorage.setItem("ip_muted", "1");
      setPlaying(false);
    } else {
      a.volume = 0.22;
      a.play().catch(() => {});
      localStorage.setItem("ip_muted", "0");
      setPlaying(true);
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/audio/terminator-style.mp3" loop preload="auto" />
      <button
        data-testid="music-toggle"
        onClick={toggle}
        aria-label={playing ? "Couper la musique" : "Activer la musique"}
        className={`glass-panel fixed bottom-5 right-5 z-[80] flex h-12 w-12 items-center justify-center rounded-full transition-all duration-300 hover:border-cyan-400/60 ${
          playing ? "shadow-[0_0_20px_rgba(0,240,255,0.35)]" : ""
        }`}
      >
        {playing ? (
          <Volume2 className="h-5 w-5 text-cyan-400" />
        ) : (
          <VolumeX className="h-5 w-5 text-slate-500" />
        )}
        {playing && (
          <span className="absolute -right-1 -top-1 flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cyan-400 opacity-60" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-cyan-400" />
          </span>
        )}
      </button>
    </>
  );
};
